export default {"src":"/_next/static/media/mask-pair-round-right.da6a7334.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};